export const getCookie  = {
	methods: {
		getCookie(cname) {
			const name = cname + '=';
			const ca = document.cookie.split(';');

			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) === ' ') {
					c = c.substring(1);
				}

				if (c.indexOf(name) === 0) {
					return c.substring(name.length, c.length);
				}
			}

			return '';
		}
	}
};


export const setCookie = {
	methods: {
		setCookie(name, value, options) {
			options = options || {};

			let expires = options.expires;

			if (typeof expires == "number" && expires) {
				let d = new Date();
				d.setTime(d.getTime() + (3600 * 1000 * 24 * 365 * 10));
				expires = options.expires = d;
			}
			if (expires && expires.toUTCString) {
				options.expires = expires.toUTCString();
			}

			value = encodeURIComponent(value);

			let updatedCookie = name + "=" + value;

			if (!options.path) {
				options.path = '/'
			}

			for (const propName in options) {
				updatedCookie += "; " + propName;
				const propValue = options[propName];
				if (propValue !== true) {
					updatedCookie += "=" + propValue;
				}
			}

			document.cookie = updatedCookie;
		}
	}
};